export const DRIVER_CODE_OF_CONDUCT = {
  id: 'driver-code-of-conduct',
  title: 'Driver Code of Conduct',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'driver',
  content: `DRIVER CODE OF CONDUCT — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This Code sets out the standards of behaviour expected of every Driver authorised to accept bookings on the Reservo platform. It supplements the Driver Agreement and the Reservo Terms of Use.

2. STATEMENT OF VALUES

Drivers on the Reservo platform commit to safety, professionalism, respect, and integrity in every trip.

3. SAFETY

3.1 A Driver MUST:
  (a) hold a current NSW driver licence appropriate to the class of vehicle operated;
  (b) hold current NSW Driver Authorisation under the Point to Point Transport (Taxis and Hire Vehicles) Act 2016;
  (c) hold current CTP and commercial vehicle insurance;
  (d) maintain the vehicle in roadworthy, clean, and mechanically sound condition;
  (e) complete the pre-trip checklist before each shift;
  (f) comply with NSW Road Rules at all times;
  (g) comply with Reservo fatigue limits (10 hours daily, 50 hours weekly, 6 consecutive days);
  (h) refuse to drive while affected by alcohol, drugs, medication causing impairment, illness, or fatigue.

3.2 A Driver MUST NOT:
  (a) use a mobile phone hand-held while driving (compliant mounting and hands-free use is permitted);
  (b) consume alcohol within 12 hours before or during a shift;
  (c) drive after refusing a roadside breath or drug test;
  (d) carry an unauthorised passenger or load;
  (e) modify the vehicle in a way that affects safety or compliance.

4. PROFESSIONAL APPEARANCE AND VEHICLE PRESENTATION

4.1 A Driver maintains a clean, neat, professional appearance.

4.2 The vehicle is clean inside and out at the start of every shift, free of strong odours, with seats in good condition and air conditioning functional.

4.3 The Driver displays no political, religious, or commercial signage in or on the vehicle other than identification required by law or by Reservo.

5. INTERACTION WITH PASSENGERS

5.1 A Driver MUST:
  (a) greet the passenger respectfully;
  (b) confirm identity using the Trip PIN;
  (c) verify the destination at trip commencement;
  (d) drive courteously, including avoiding unnecessary acceleration, hard braking, and aggressive lane changes;
  (e) assist with luggage where requested and safely possible;
  (f) follow any specific instructions in the booking (child seat, accessibility, multiple stops, particular routes);
  (g) end the trip at the destination promptly and safely.

5.2 A Driver MUST NOT:
  (a) initiate conversations on personal, romantic, religious, or political topics;
  (b) ask the passenger for personal contact details beyond what is necessary for the trip;
  (c) contact a passenger outside the in-app messaging system;
  (d) accept tips outside the Reservo platform;
  (e) take routes longer than reasonably necessary;
  (f) eat, drink, or smoke in the vehicle while a passenger is present (other than water);
  (g) play music, radio, or media at a volume the passenger has not agreed to;
  (h) make personal comments on the passenger's appearance, clothing, accent, race, religion, sexuality, or any other protected attribute;
  (i) photograph or record the passenger without express consent.

6. ACCESSIBILITY AND VULNERABLE PASSENGERS

6.1 A Driver complies with the Reservo Accessibility Policy and Vulnerable Passenger Policy.

6.2 Specifically, a Driver:
  (a) MUST carry guide and support animals at no extra charge;
  (b) MUST provide reasonable assistance to passengers with mobility aids;
  (c) MUST NOT refuse service on the basis of disability;
  (d) MUST NOT charge differential fees for accessibility support;
  (e) MUST follow the unaccompanied-minor protocol if applicable.

7. ANTI-DISCRIMINATION AND ANTI-HARASSMENT

7.1 A Driver complies with the Reservo Anti-Discrimination Policy.

7.2 A Driver MUST NOT discriminate against, harass, or vilify a passenger on the basis of any protected attribute.

8. SAFETY AND SECURITY

8.1 A Driver:
  (a) uses the in-app SOS feature in genuine emergencies;
  (b) reports incidents through the in-app reporting form within the statutory timeframe;
  (c) cooperates with Reservo Operations on safety matters;
  (d) does not retaliate against a passenger who has lodged a complaint.

8.2 A Driver does not record audio in the vehicle. (See Audio Recording Policy.)

9. DATA AND PRIVACY

9.1 A Driver:
  (a) uses Rider personal information only for performing the trip;
  (b) does not contact Riders outside the platform;
  (c) does not use Rider data for marketing or any other purpose;
  (d) does not screenshot, photograph, or otherwise capture Rider personal information from the app.

10. INTEGRITY

10.1 A Driver:
  (a) does not solicit off-platform bookings from Riders introduced through Reservo;
  (b) does not accept off-platform payment from Riders;
  (c) does not collude with a Rider to inflate or deflate fares;
  (d) does not manipulate ratings or the rewards program;
  (e) does not impersonate another Driver, a Reservo administrator, or any other person.

11. COMPLIANCE OBLIGATIONS

11.1 A Driver:
  (a) keeps driver authorisation, vehicle authorisation, licence, and insurance current;
  (b) responds to document expiry warnings issued by Reservo;
  (c) participates in annual re-checks;
  (d) completes annual refresher training modules;
  (e) attends induction and ongoing training as required.

12. CONSEQUENCES OF BREACH

12.1 Breach of this Code may result in:
  (a) written warning;
  (b) required additional training;
  (c) temporary suspension;
  (d) permanent termination of Driver status;
  (e) referral to the NSW Point to Point Transport Commissioner;
  (f) referral to NSW Police where a criminal offence is suspected;
  (g) referral to anti-discrimination authorities;
  (h) civil claims.

13. ACKNOWLEDGEMENT

Every Driver acknowledges acceptance of this Code at onboarding and at each annual re-check.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};